export default __webpack_public_path__ + "static/media/btnReconnect.7fb2efdf.svg";